import React from 'react';

const DragIcon = (props) => {
    return (
        <svg width={27} height={14} {...props}>
            <path
                d="M26.98 6.84l-10.88 6.8V.04l10.88 6.8zm-26.52 0l10.88 6.8V.04L.46 6.84z"
            />
        </svg>
    );
};

export default DragIcon;
